// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_2ER","cls2":"PremiumBadge-cls2_E9C PremiumBadge-cls1_2ER"};